import moment from 'moment-timezone'
import { NAMES as ROUTE_NAMES } from '@/routes'

export default {
    methods: {
        currentRouteHasPackageSlug () {
            return !!this.$route.params.packageSlug
        },
        currentRouteHasCollectionSlug () {
            return !!this.$route.params.collectionSlug
        },
        currentRouteHasLearningPathSlug () {
            return !!this.$route.params.learningPathSlug
        },
        isCourseWebinar (course) {
            return !!(course && course.type && course.type.value === 'webinar')
        },
        isVirtualClassroom (course) {
            return !!(course && course.type && course.type.value === 'virtual_classroom')
        },
        isUpcoming (courseOrCollection) {
            const publishDate = courseOrCollection.publishedDate || courseOrCollection.publishDate
            if (!publishDate) {
                return false
            }
            const today = moment().tz(this.getTimeZone()).startOf('day')
            return today.diff(publishDate, 'days') < 0
        },
        goToCourseBySlug (courseSlug) {
            const name = 'course-without-package'
            const params = { courseSlug }
            return this.$router.push({ name, params })
        },
        getRouteToCourse (course) {
            const courseSlug = course.slug
            const packageSlug = this.$route.params.packageSlug
            const collectionSlug = this.$route.params.collectionSlug
            const learningPathSlug = this.$route.params.learningPathSlug
            let name = 'course-without-package'
            let params = { courseSlug }
            switch (true) {
            case this.isCourseWebinar(course) && this.currentRouteHasPackageSlug() && this.currentRouteHasCollectionSlug():
                name = 'collection-page-course-page-live'
                params = { courseSlug, packageSlug, collectionSlug }
                break
            case this.isCourseWebinar(course) && this.currentRouteHasPackageSlug():
                name = 'course-list-course-page-live'
                params = { courseSlug, packageSlug }
                break
            case this.isCourseWebinar(course) && this.currentRouteHasCollectionSlug():
                name = 'collection-page-course-page-live-without-package'
                params = { courseSlug, collectionSlug }
                break

            case this.isVirtualClassroom(course) && this.currentRouteHasPackageSlug() && this.currentRouteHasCollectionSlug():
                name = 'collection-page-course-page-virtual-classroom'
                params = { courseSlug, packageSlug, collectionSlug }
                break
            case this.isVirtualClassroom(course) && this.currentRouteHasPackageSlug():
                name = 'course-list-course-page-virtual-classroom'
                params = { courseSlug, packageSlug }
                break
            case this.isVirtualClassroom(course) && this.currentRouteHasCollectionSlug():
                name = 'collection-page-course-page-virtual-classroom-without-package'
                params = { courseSlug, collectionSlug }
                break
            case this.currentRouteHasPackageSlug() && this.currentRouteHasCollectionSlug():
                name = 'collection-page-course-page'
                params = { courseSlug, packageSlug, collectionSlug }
                break
            case this.currentRouteHasPackageSlug() && this.currentRouteHasLearningPathSlug():
                name = 'learning-path-page-course-page'
                params = { courseSlug, packageSlug, learningPathSlug }
                break
            case this.currentRouteHasPackageSlug():
                name = 'course-list-course-page'
                params = { courseSlug, packageSlug }
                break
            case this.currentRouteHasCollectionSlug():
                name = 'collection-page-course-page-without-package'
                params = { courseSlug, collectionSlug }
                break
            case this.currentRouteHasLearningPathSlug():
                name = 'learning-path-course-page-without-package'
                params = { courseSlug, learningPathSlug }
                break
            case this.isCourseWebinar(course):
                name = 'course-without-package-live'
                params = { courseSlug }
                break
            case this.isVirtualClassroom(course):
                name = 'course-without-package-virtual-classroom'
                params = { courseSlug }
                break
            }
            return { name, params }
        },
        goToCollection (collectionSlug) {
            return this.$router.push(this.getRouteToCollection(collectionSlug))
        },
        getRouteToCollection (collectionSlug, collection = null) {
            let name = ROUTE_NAMES.COLLECTION_PAGE_WITHOUT_PACKAGE
            let params = { collectionSlug }
            const packageSlug = this.$route.params.packageSlug

            if (packageSlug) {
                name = ROUTE_NAMES.COLLECTION_PAGE
                params = { ...params, packageSlug }
            }

            return { name, params }
        },
        getRouteToLearningPath (learningPathSlug, learningPath = null) {
            let name = ROUTE_NAMES.LEARNING_PATH_PAGE_WITHOUT_PACKAGE
            let params = { learningPathSlug }
            const packageSlug = this.$route.params.packageSlug

            if (packageSlug) {
                name = ROUTE_NAMES.LEARNING_PATH_PAGE
                params = { ...params, packageSlug }
            }

            return { name, params }
        },
        getRouteToCollectionFromParams () {
            const collectionSlug = this.$route.params.collectionSlug
            return this.getRouteToCollection(collectionSlug)
        },
        checkAndSetNewUrlSlug (courseElement, courseType) {
            const slugName = `${courseType}Slug`
            if (courseElement.slug !== this.$route.params.courseSlug) {
                this.$router.push({ name: this.$route.name, params: { [slugName]: courseElement.slug } })
            }
        }
    }
}
